export enum ENV_LIST {
    LOCAL = 'local',
    STAGING = 'staging',
    REVIEW_APP = 'review_app',
    DEMO_01 = 'demo01',
    SANDBOX = 'sandbox',
    PRODUCTION = 'production',
}

export enum AvailableToggleFeatures {
    connector_shopify = 'connector_shopify',
    connector_stockit = 'connector_stockit',
}

const featuresByEnv = Object.freeze({
    // Usage example:
    // [ENV_LIST.LOCAL]: [AvailableToggleFeatures.ma_feature]
    [ENV_LIST.LOCAL]: [AvailableToggleFeatures.connector_shopify, AvailableToggleFeatures.connector_stockit],
    [ENV_LIST.STAGING]: [AvailableToggleFeatures.connector_shopify, AvailableToggleFeatures.connector_stockit],
    [ENV_LIST.REVIEW_APP]: [AvailableToggleFeatures.connector_shopify, AvailableToggleFeatures.connector_stockit],
    [ENV_LIST.DEMO_01]: [],
    [ENV_LIST.SANDBOX]: [],
    [ENV_LIST.PRODUCTION]: [],
});

export function getEnabledFeaturesByEnv(envName: ENV_LIST) {
    return featuresByEnv?.[envName];
}
